module.exports = __webpack_public_path__ + "static/media/suen.2b06556a.png";